import AppModal from '@components/AppModal';
import Text from '@components/Text';
import { ActivityComponentType, useFlow } from '@stackflow/react';
import { useTranslation, Trans } from 'react-i18next';

interface Params {
    shopId: string;
}

declare module '@stackflow/config' {
    interface Register {
        ShopPrepareModal: Params;
    }
}

const ShopPrepareModal: ActivityComponentType<'ShopPrepareModal'> = ({ params }) => {
    const { shopId } = params;
    const { t } = useTranslation('shopPrepare');
    const { pop, push } = useFlow();
    const handleMove = () => {
        pop({ animate: false });
        push('ItemsActivity', { shopId, type: 'ALL' });
    };
    return (
        <AppModal deny={t('button.cancel')}
            confirm={t('button.viewMenu')}
            onConfirm={handleMove} >
            <Text size='title' align='center'>
                <Trans ns="shopPrepare" i18nKey="message" components={{ br: <br /> }} />
            </Text>
            <Text size='body-long' color='var(--color-gray6)' align='center'>
                {t('notice')}
            </Text>
        </AppModal>
    );
};

export default ShopPrepareModal;
